module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-overlay grid"
  }, [_c('div', {
    staticClass: "grid--row  gallery-overlay--row"
  }, [_c('div', {
    staticClass: "grid--col gallery-overlay--col"
  }, [_c('cmp-carousel', {
    attrs: {
      "items": _vm.plugins,
      "facet": "gallery-overlay",
      "show-arrows": true,
      "show-pagination": false,
      "show-item-count": true,
      "passive-mode": false,
      "preload-range": 1,
      "allow-arrow-keys": true,
      "idx": _vm.idx
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "gallery-overlay--carousel-item grid"
        }, [_c(props.item.type, {
          tag: "component",
          attrs: {
            "facet": "gallery-overlay",
            "plugin": props.item,
            "preload": props.isActive,
            "resource-name": "image"
          }
        })], 1)]
      }
    }])
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27871866", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27871866","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/gallery/gallery-overlay/index.vue
// module id = 518
// module chunks = 7